import mock from './mock';
import './sicherheitslaeuchten/NotstromArtikelData';
import './sicherheitslaeuchten/ChemischeprodukteArtikelData';

mock.onAny().passThrough();
